"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TargetDisplaySize_1 = require("./TargetDisplaySize");

var VideoPreference = /*#__PURE__*/function () {
  /** Initializes a [[VideoPreference]] with the given properties.
   *
   * @param attendeeId Attendee ID of the client
   * @param priority The relative priority of this attendee against others.
   * @param targetSize The desired maximum simulcast layers to receive.
   */
  function VideoPreference(attendeeId, priority, targetSize) {
    _classCallCheck(this, VideoPreference);

    this.attendeeId = attendeeId;
    this.priority = priority;
    this.targetSize = targetSize !== undefined ? targetSize : TargetDisplaySize_1.default.High;
  }

  _createClass(VideoPreference, [{
    key: "partialCompare",
    value: function partialCompare(other) {
      return this.priority - other.priority;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.attendeeId === other.attendeeId && this.targetSize === other.targetSize && this.priority === other.priority;
    }
  }, {
    key: "targetSizeToBitrateKbps",
    value: function targetSizeToBitrateKbps(targetSize) {
      switch (targetSize) {
        case TargetDisplaySize_1.default.High:
          return VideoPreference.HIGH_BITRATE_KBPS;

        case TargetDisplaySize_1.default.Medium:
          return VideoPreference.MID_BITRATE_KBPS;

        case TargetDisplaySize_1.default.Low:
          return VideoPreference.LOW_BITRATE_KBPS;
      }
    }
  }]);

  return VideoPreference;
}();

exports.default = VideoPreference;
VideoPreference.LOW_BITRATE_KBPS = 300;
VideoPreference.MID_BITRATE_KBPS = 600;
VideoPreference.HIGH_BITRATE_KBPS = 1200;